import React from 'react'

import FormManager from "../../../../gd-form/common/form-manager"
import CustomFieldAddFormProto, {CustomFieldAddFormProto_Props} from "../../add-form-proto"
import CustomFieldLeftPanel from "../../common/panel/form-left-panel"
import CustomFieldPreview from "../../common/form-preview"
import CustomFieldRightPanel from "../../common/panel/form-right-panel"
import CustomFieldDecimalPlaces from "../../common/form-decimal-places"
import CustomFieldSymbol from "../../common/form-symbol"
import CustomFieldPositiveOnly from "../../common/form-positive-only"
import CustomFieldIntegersOnly from "../../common/form-integers-only"

export default class CurrencyCustomFieldForm extends CustomFieldAddFormProto {

    public form: FormManager

    constructor(props: CustomFieldAddFormProto_Props) {
        super(props)

        this.type = gd.const.customFields.type.CURRENCY

        this.initFormData.decimalPlaces = null
        this.initFormData.symbol        = 'us_dollar'
        this.initFormData.positiveOnly  = false
        this.initFormData.integersOnly  = false

        if (this.props.customField) {
            this.initFormData.decimalPlaces = this.props.customField.params && this.props.customField.params.decimalPlaces
            this.initFormData.symbol        = _.get(this.props.customField.params,'symbol','us_dollar')
            this.initFormData.positiveOnly  = _.get(this.props.customField.params,'positiveOnly', false)
            this.initFormData.integersOnly  = _.get(this.props.customField.params,'integersOnly', false)
        }

        this.state = {
            noDecimalPlaces: this.initFormData.integersOnly
        }

        this.formStructure.fields.decimalPlaces = {
            type            : 'select',
            isRequired      : false,
            label           : 'Decimal places',
            onUserChange    : () =>  this.setState({reRender: 1})
        };

        this.formStructure.fields.symbol = {
            type            : 'select',
            isRequired      : false,
            label           : 'Symbol',
            onUserChange    : () => this.setState({reRender: 1})
        };

        this.formStructure.fields.positiveOnly = {
            type        : 'select',
            isRequired  : true,
            label       : 'Positive only'
        }

        this.formStructure.fields.integersOnly = {
            type            : 'select',
            isRequired      : true,
            label           : 'Integers only',
            onUserChange    : () => {
                // hide decimal places and set no 0 if integersOnly is true
                this.form.setValue('decimalPlaces', 0)
                this.setState({noDecimalPlaces: this.form.getValue('integersOnly')})
            }
        }

        this.form = new FormManager(this.formStructure, this.initFormData)
    }

    onSubmit(result: any) {
        result.name = result.name.trim()
        result.type = gd.const.customFields.type.CURRENCY

        result.params = {
            displayName     : result.displayName?.trim(),
            symbol          : result.symbol,
            decimalPlaces   : result.decimalPlaces,
            scope           : result.scope,
            positiveOnly    : result.positiveOnly,
            integersOnly    : result.integersOnly
        }

        this.props.onSubmit(result)
    }

    getCurrencyMark() {
        const currencyId = this.form.getValue('symbol')
        let currencyMark = ''

        for (let availableCurrId in gd.const.currency) {
            if (availableCurrId === currencyId)  {
                currencyMark = gd.const.currency[availableCurrId].symbol
                break
            }
        }

        return currencyMark
    }

    render() {
        const currencyMark = this.getCurrencyMark()

        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        <div className="txt m-l-15">{currencyMark} {gd.utils.Format.number(1500.45,this.form.getValue('decimalPlaces'),true)}</div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldSymbol form={this.form}/>

                    <CustomFieldPositiveOnly form={this.form}/>
                    <CustomFieldIntegersOnly form={this.form}/>

                    {!this.state.noDecimalPlaces &&
                        <CustomFieldDecimalPlaces form={this.form}/>}
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}